import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ListIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.112 4.733h3.763v.533H3.112v-.533ZM3.112 5.8h3.763v.533H3.112V5.8ZM6.87 6.867H3.111V7.4H6.87v-.533Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6.816 1.533 1.146 1.136.538.531V9h-7V1h4.777l.539.533Zm-.47 1.6H7.67l-1.323-1.31v1.31ZM2.038 8.467h5.924v-4.8H5.808V1.533h-3.77v6.934Z"
            />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const ListIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M3.112 4.733h3.763v.533H3.112v-.533ZM3.112 5.8h3.763v.533H3.112V5.8ZM6.87 6.867H3.111V7.4H6.87v-.533Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m6.816 1.533 1.146 1.136.538.531V9h-7V1h4.777l.539.533Zm-.47 1.6H7.67l-1.323-1.31v1.31ZM2.038 8.467h5.924v-4.8H5.808V1.533h-3.77v6.934Z"
            />
        </SvgIcon>
    );
};
